module.exports = __webpack_public_path__ + "assets/img/18_1671.8ea22d3b.jpg";